<template>
  <div style="padding-top: 3rem">
    <van-loading size="24px" style="text-align: center" type="spinner">加载中...</van-loading>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Loading } from 'vant';
    export default {
      name:"loading",

      components: {
        [Loading.name]: Loading,
      },

    }
</script>

<style scoped>

    @keyframes load{
      0%   {transform: translateY(0px);}
      50%  {transform: translateY(-50px);}
      100% {transform: translateY(0px);}
    }

    @keyframes ellipse{
      0%   {transform: scale(1);}
      50%  {transform: scale(0.3);}
      100% {transform: scale(1);}
    }
</style>



// WEBPACK FOOTER //
// src/components/page/common/loading.vue